import React from 'react';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';

type GoogleMapProps = {
  width: number | 'full';
  height: number;
  position: { lat: number; lng: number };
};

export const GoogleMap = ({ width, height, position }: GoogleMapProps) => (
  <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
    <Map
      center={position}
      zoom={10}
      disableDefaultUI={true}
      style={{
        width: width === 'full' ? '100%' : `${width}px`,
        height: `${height}px`,
      }}
    >
      <Marker position={position} />
    </Map>
  </APIProvider>
);
